"use strict";

var get = require('lodash.get');
var makeRefreshToken = function makeRefreshToken(_ref) {
  var client = _ref.client,
    setTokenInCookie = _ref.setTokenInCookie,
    removeTokenFromCookie = _ref.removeTokenFromCookie;
  return function () {
    var isTokenInCookie = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    return client.checkSessionAsync({}).then(function (authResult) {
      var newToken = get(authResult, 'accessToken');
      setTokenInCookie(newToken);
      return newToken;
    }).catch(function (err) {
      removeTokenFromCookie();
      var message = err.description || err.error_description || err.errorDescription || err.message;
      if (isTokenInCookie) {
        throw new Error("Unable to refresh token. Cause: ".concat(message));
      }
      throw new Error("User not logged in, unable to refresh token. Cause: ".concat(message));
    });
  };
};
module.exports = {
  makeRefreshToken: makeRefreshToken
};